export default 'https://tme.understood.org/assets/collectible.d99d75e2.glb'